import { gql } from '@apollo/client'
import { STORE_FRAGMENT } from '../fragments'

export const GET_STORES = gql`
  query GetStores($input: CompanyStoresInput!) {
    companyStores(input: $input) {
      hasMore
      count
      results {
        ...Store
      }
    }
  }
  ${STORE_FRAGMENT}
`
